<div class="nk-form jp">
  <p class="halvany jp-sugo">
    {{ ev }}. évi értékek – az intézmény <b>minden ügyfelére</b> érvényesek. Ami az évre nincs megadva, az a korábbi év
    értéke, végül a program alapértéke. Az „ellenőrizendő” jelölésű értékek forrását érdemes a hatályos jogszabályon
    ellenőrizni.
  </p>
  <div class="n-panel jp-csoport" *ngFor="let c of csoportLista">
    <div class="n-panel-cim">{{ csoportCim[c] || c }}</div>
    <div class="jp-sor" *ngFor="let p of csoportSorai(c)">
      <label class="kv-mezo">
        <span>{{ p.cim }}</span>
        <span class="kv-egyutt">
          <input type="number" [(ngModel)]="p.szerk" [readonly]="p.forras === 'beallitas'" [class.kv-ro]="p.forras === 'beallitas'" step="any">
          <span class="jp-egyseg">{{ egyseg(p) }}</span>
          <button type="button" class="kv-mini" *ngIf="p.forras === 'ev' && !p.torol" (click)="visszaallit(p)"
                  title="Az év saját értékének törlése (visszaáll az örökölt / alapértékre)"><ion-icon name="refresh-outline"></ion-icon></button>
        </span>
      </label>
      <div class="jp-meta">
        <span class="cimke" [class.petrol]="p.forras === 'beallitas'" [class.zold]="p.forras === 'ev'">{{ forrasCim(p) }}</span>
        <span class="cimke sarga" *ngIf="p.ellenorizendo" title="A forrás nem hivatalos vagy régi – a hatályos jogszabályon ellenőrizendő">ellenőrizendő</span>
        <span class="halvany">{{ p.jogforras }}</span>
        <span class="halvany" *ngIf="p.forras !== 'alap'">· alapérték: {{ alapSzoveg(p) }}</span>
        <span class="jp-forras" *ngIf="p.forras === 'beallitas'">Módosítás: Szervíz → Bérszámfejtés beállításai</span>
      </div>
    </div>
  </div>
  <div class="nk-lab">
    <button type="button" class="ov-gomb fo" (click)="ment()" [disabled]="mentes"><ion-icon name="save-outline"></ion-icon>Mentés</button>
  </div>
</div>
